import { useLazyQuery, useQuery } from "@apollo/client/react";import { useEffect, useState } from "react";
import { usePersistFilters } from "../../../hooks/usePersistFilters";

import { GET_DELEGACIONES_BY_USUARIO } from "../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario";
import { adaptDelegacionArray, adaptDelegacionWithoutAllArray } from "../../../adapters/delegacionAdapter";
import { GET_USUARIO_DELEGACION_ORIGEN } from "../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen";
import moment from "moment";
import { adaptEstadosSugerenciaArray, GET_ESTADOS_SUGERENCIAS_MONITOREO } from "../../../data/graphQL/queries/AdminSugerenciasMonitoreo/getEstadosProfesionalMonitoreoSugerencia";

const userId = sessionStorage.getItem('idUsuario');

export const useGetFilters = (setIsRefetchRequired) => {

  const [delegacionOrigen, setDelegacionOrigen] = useState(0);
  const [delegaciones, setDelegaciones] = useState([]);
  const [estadosSugerencias, setEstadosSugerencias] = useState([]);

  const { filters, handleChangeFilters } = usePersistFilters({
    idDelegacion: delegacionOrigen,
    txtFiltro: '',
    fechaDesde: moment().add(-10, 'd').format('yyyy-MM-DD'),
    fechaHasta: moment().add(20, 'd').format('yyyy-MM-DD'),
    idEstado: 0
  }, `AdminSugerenciasMonitoreoFilter`);

  const { data: dataEstadosSugerenciasMonitoreo } = useQuery(GET_ESTADOS_SUGERENCIAS_MONITOREO);

  useEffect(() => {
    if (!dataEstadosSugerenciasMonitoreo) return;
    setEstadosSugerencias(adaptEstadosSugerenciaArray(dataEstadosSugerenciasMonitoreo));
  }, [dataEstadosSugerenciasMonitoreo]);

  const [getDelegaciones, { data: dataDelegaciones, loading: delegacionesLoading }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegaciones || delegacionesLoading) return;
    setDelegaciones(adaptDelegacionWithoutAllArray(dataDelegaciones));
  }, [dataDelegaciones]);

  const [getDelegacionOrigen, { data: dataDelegacionOrigen, loading: delegacionOrigenLoading }] = useLazyQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegacionOrigen || delegacionOrigenLoading) return;
    if (dataDelegacionOrigen.usuarioFull.success) {
      const deleg = parseInt(dataDelegacionOrigen.usuarioFull.valorEsperado.delegacionOrigen, 10);
      sessionStorage.setItem('delegacionOrigen', deleg);
      setDelegacionOrigen(deleg);

      if (filters.idDelegacion == 0)
      handleChangeFilters('idDelegacion', deleg);
    }
  }, [dataDelegacionOrigen]);

  useEffect(() => {
    if (!delegacionesLoading) {
      getDelegaciones({variables: { idUsuario: JSON.parse(userId, 10) }});
    }
    getDelegacionOrigen({variables: { idUsuario: JSON.parse(userId, 10) }});
  }, []);

  const applyTextFilter = (data, textFilter) => {
    const inputBuscar = textFilter?.trim().toUpperCase();

    if (inputBuscar === "") return data;

    const dataFiltered = data.filter((sugerencia) => {
      const id = sugerencia?.idSugerenciaMonitoreo?.toString().toUpperCase() || "";
      const contratoProfesional = sugerencia?.contratoProfesional?.toString().toUpperCase() || "";
      const idDelegacion = sugerencia?.idDelegacionResponsable?.toString().toUpperCase() || "";
      const nombreProfesional = sugerencia?.nombreProfesional?.toString().toUpperCase() || "";
      const claseActual = sugerencia?.claseActual?.toString().toUpperCase() || "";
      const claseSugerida = sugerencia?.claseSugerida?.toString().toUpperCase() || "";
      const resultadoUltimoMonitoreo = sugerencia?.resultadoUltimoMonitoreo?.toString().toUpperCase() || "";
      const solicitud = sugerencia?.solicitud?.toString().toUpperCase() || "";
      const estado = sugerencia?.estado?.toString().toUpperCase() || "";
      const solicitante = sugerencia?.solicitante?.toString().toUpperCase() || "";
      const autorizador = sugerencia?.autorizador?.toString().toUpperCase() || "";

      return (
        id.includes(inputBuscar) ||
        contratoProfesional.includes(inputBuscar) ||
        idDelegacion.includes(inputBuscar) ||
        nombreProfesional.includes(inputBuscar) ||
        claseActual.includes(inputBuscar) ||
        claseSugerida.includes(inputBuscar) ||
        resultadoUltimoMonitoreo.includes(inputBuscar) ||
        solicitud.includes(inputBuscar) ||
        estado.includes(inputBuscar) ||
        solicitante.includes(inputBuscar) ||
        autorizador.includes(inputBuscar));

    });

    return dataFiltered;
  };

  const applyClientSideFilters = (data, textFilter) => {
    const dataFilteredByText = applyTextFilter(data, textFilter);

    // const dataFilteredByEstadoPaciente = applyEstadoPacienteFilter(
    //   dataFilteredByText,
    //   estadoFilter
    // );
    // return dataFilteredByEstadoPaciente;

    return dataFilteredByText;
  };

  return {
    delegaciones,
    delegacionOrigen,
    estadosSugerencias,
    filters,
    handleChangeFilters,
    applyTextFilter,
    applyClientSideFilters
  };
};